import { PhotoData } from "../../photo/interfaces/dto";
import { PhotoPopupData } from "../interfaces/dto";

declare var pm: PmInterface;

export default function generatePopupData(
	popup: HTMLElement,
	photoData: PhotoData,
	gridPhotoWrapper: HTMLElement | null,
): PhotoPopupData {
	const { findHtmlEl } = pm.utils.dom;

	const captionOriginEl = findHtmlEl(gridPhotoWrapper, ".photo-caption");

	return {
		photoReportingNonce: popup.dataset.reportPhotoNonce
			? popup.dataset.reportPhotoNonce
			: "",
		isPhotoAuthor: photoData.authorId === pm.currentUser.id,
		isLoggedIn: pm.currentUser.isLoggedIn,
		photoId: photoData.id,
		id: photoData.id,
		postId: photoData.id,
		date: photoData.date,
		hasDescription: !!photoData.description,
		description: photoData.description,
		formattedDescription: captionOriginEl
			? captionOriginEl.innerHTML
			: photoData.description,
		attachmentUrl: photoData.attachmentUrl,
		authorId: photoData.authorId,
		authorNicename: photoData.authorNicename,
		authorDisplayName: photoData.authorDisplayName,
		authorProfileUrl: photoData.authorProfileUrl,
		authorAvatarUrl: photoData.authorAvatarUrl,
		authorMembershipType: photoData.authorMembershipType,
		potd: photoData.potd,
		featured: photoData.featured,
		address: photoData.address,
		album: photoData.album,
		imageTitle: photoData.imageTitle,
		aperture: photoData.aperture,
		shutterSpeed: photoData.shutterSpeed,
		iso: photoData.iso,
		camera: photoData.camera,
		cameraSlug: photoData.cameraSlug,
		cameraUrl: photoData.cameraUrl,
		cameraAlias: photoData.cameraAlias,
		focalLength: photoData.focalLength,
		editableCamera: photoData.editableCamera,
		editableFocalLength: photoData.editableFocalLength,
		url: photoData.url,
		urlLarge: photoData.urlLarge,
		isLiked: photoData.isLiked,
		categories: photoData.categories,
		videoUrl: photoData.videoUrl,
	};
}
